export async function parseFromContext(data, loaders, options, context) {
  return context._parse(data, loaders, options, context);
}
export function parseSyncFromContext(data, loader, options, context) {
  if (!context._parseSync) {
    throw new Error('parseSync');
  }
  return context._parseSync(data, loader, options, context);
}
export async function parseInBatchesFromContext(data, loader, options, context) {
  if (!context._parseInBatches) {
    throw new Error('parseInBatches');
  }
  return context._parseInBatches(data, loader, options, context);
}
//# sourceMappingURL=loader-types.js.map